import NewsList_6 from './NewsList_6';

export type { NewsList_6_Props } from './NewsList_6';
export default NewsList_6;
export { NewsList_6 };
